<template>
  <div
    class="pointer"
    @click="$router.push({path: '/'})"
  >
    <img
      src="@/assets/logo/ochpower.svg"
      width="100"
      alt="ochpower logo"
    >
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'ui'
      ])
    }
  }
</script>

<style scoped>

</style>
